
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiIecChartDispSetProposal as ObiIecChartDispSetProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-iec-chart-disp-set-proposal.js';
 
 
 

 
 export const ObiIecChartDispSetProposal = createComponent({
   react: React,
   tagName: 'obi-iec-chart-disp-set-proposal',
   elementClass: ObiIecChartDispSetProposalElement,
   events: {
     
   }
  });
 
 